exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".grid[data-v-5f48b3e2]{display:grid;grid-gap:var(--grid-gap);padding:var(--grid-padY) var(--grid-padX)}", ""]);

// exports
